/**
 * Subscription LP buy box — variant picker, tiered selling plans, gallery (mm-sublp-main-product only)
 */

(function () {
  if (typeof u_FormatMoney !== 'function') {
    window.u_FormatMoney = (cents, format = '${{amount}}') => {
      if (typeof cents == 'string') cents = cents.replace('.', '');
      var v = '',
        r = /\{\{\s*(\w+)\s*\}\}/,
        f = format || '${{amount}}';
      var d = (o, def) => (typeof o == 'undefined' ? def : o);
      var fm = (n, p, t, dec) => {
        p = d(p, 2);
        t = d(t, ',');
        dec = d(dec, '.');
        if (isNaN(n) || n == null) return 0;
        n = (n / 100).toFixed(p);
        var x = n.split('.'),
          $ = x[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t),
          c = x[1] ? dec + x[1] : '';
        return $ + c;
      };
      var m = f.match(r);
      if (m)
        switch (m[1]) {
          case 'amount':
            v = fm(cents, 2);
            break;
          case 'amount_no_decimals':
            v = fm(cents, 0);
            break;
          case 'amount_with_comma_separator':
            v = fm(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            v = fm(cents, 0, '.', ',');
            break;
        }
      return f.replace(r, v);
    };
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('mmSublpProduct', () => ({
      product: null,
      currentVariant: null,
      variantColors: {},
      sellingPlanId: null,
      subscriptionType: 'subscribe',
      subscriptionTier: '90',
      quantity: 1,

      init() {
        this.product = JSON.parse(this.$el.dataset.product);
        this.currentVariant = JSON.parse(this.$el.dataset.currentVariant);
        this.variantColors = JSON.parse(this.$el.dataset.variantColors || '{}');

        if (this.currentVariant.selling_plan_allocations?.length) {
          this.e_SelectSubscriptionTier('90');
        }

        this.$nextTick(this.InitSwiper.bind(this));
        this.$watch('ImagesByVariant', this.InitSwiper.bind(this));
      },

      get variantColor() {
        return this.variantColors[this.currentVariant.id] || null;
      },
      get isSubscription() {
        return this.subscriptionType === 'subscribe';
      },
      set isSubscription(val) {
        this.subscriptionType = val ? 'subscribe' : 'one-time';
      },
      get ImagesByVariant() {
        let media = this.product.media;
        let media_by_variant = media.filter((media) => {
          if (!media.alt) {
            media.alt = '';
            return true;
          }
          let media_type = media.alt.split('|||')[0];
          let media_variant_sku = media_type.split('--')[1];
          if (!media_type || !media_variant_sku || !this.currentVariant.sku) return false;
          return !!media_type && media_type.includes('variant') && media_variant_sku.includes(this.currentVariant.sku);
        });
        let media_lifestyle = media.filter((media) => {
          let media_type = media.alt.split('|||')[0];
          if (!media_type) return false;
          return media_type.includes('lifestyle');
        });
        return [...media_by_variant, ...media_lifestyle];
      },

      e_UpdateSelectedVariant(e) {
        let options = e.currentTarget.querySelectorAll('input[type="radio"]');
        let selectedValues = Array.from(options)
          .filter((option) => option.checked)
          .map((option) => option.value);
        let selectedVariant = this.product.variants.find(
          (variant) => variant.options.join('/') == selectedValues.join('/')
        );

        if (!selectedVariant) {
          let lastSelected = e.target.value;
          selectedVariant = this.product.variants.find((variant) => variant.options.includes(lastSelected));
        }

        this.currentVariant = selectedVariant;
        if (selectedVariant.selling_plan_allocations?.length) {
          this.e_SelectSubscriptionTier(this.subscriptionTier);
        }
        document.dispatchEvent(
          new CustomEvent('variant:change', {
            detail: { variant: this.currentVariant },
          })
        );
      },

      u_FormatMoney(cents) {
        return u_FormatMoney(cents);
      },

      u_SublpPlanMatch(tier) {
        const el = this.$el.querySelector('.mm-sublp-options');
        if (!el) return tier === '90' ? '90' : '30';
        if (tier === '90') return el.dataset.planMatch90 || '90';
        return el.dataset.planMatch30 || '30';
      },

      u_SublpAllPlans() {
        const groups = this.product?.selling_plan_groups || [];
        return groups.flatMap((g) => g.selling_plans || []);
      },

      u_SublpVariantPlanEntries(variant) {
        const allocations = variant?.selling_plan_allocations || [];
        const allPlans = this.u_SublpAllPlans();
        return allocations.map((a) => {
          const plan = allPlans.find((p) => Number(p.id) === Number(a.selling_plan_id));
          return {
            selling_plan_id: a.selling_plan_id,
            name: (plan?.name || '').trim().toLowerCase(),
          };
        });
      },

      u_SublpIsShortIntervalPlan(name) {
        return /\b2\s*week|\bevery\s+2\s*week|bi-?weekly|fortnight/i.test(name);
      },

      u_SublpScorePlanName(name, tier) {
        if (!name) return 0;
        if (tier === '90') {
          if (this.u_SublpIsShortIntervalPlan(name)) return 0;
          if (/\b12\s*weeks?\b/i.test(name)) return 100;
          if (/\b90[\s-]*day|\bevery\s+90\b|90\s*days?|\b3\s*months?\b|\bquarter/i.test(name)) return 95;
          if (/\b90\b/.test(name)) return 55;
          return 0;
        }
        if (tier === '30') {
          if (this.u_SublpIsShortIntervalPlan(name)) return 0;
          if (/\b6\s*weeks?\b/i.test(name)) return 0;
          if (/\b12\s*weeks?\b/i.test(name)) return 0;
          if (/\bevery\s+4\s*week|\bdelivery\s+every\s+4\s*week/i.test(name)) return 100;
          if (/\b30[\s-]*day|\bevery\s+30\b|30\s*days?/i.test(name)) return 95;
          if (/\bevery\s+month\b|\bmonthly\b|\b1\s*month\b/i.test(name) && !/week/i.test(name)) return 90;
          if (/\b30\b/.test(name) && !/\b90\b/.test(name)) return 55;
          return 0;
        }
        return 0;
      },

      u_SublpResolveSellingPlanId(variant, tier) {
        const allocations = variant?.selling_plan_allocations;
        if (!allocations?.length || tier === 'one-time') return null;

        const el = this.$el.querySelector('.mm-sublp-options');
        const overrideRaw = tier === '90' ? el?.dataset?.planId90 : el?.dataset?.planId30;
        if (overrideRaw) {
          const overrideId = Number(overrideRaw);
          if (!Number.isNaN(overrideId) && allocations.some((a) => Number(a.selling_plan_id) === overrideId)) {
            return overrideId;
          }
        }

        const entries = this.u_SublpVariantPlanEntries(variant);
        const token = String(this.u_SublpPlanMatch(tier) || '').toLowerCase();

        let best = null;
        let bestScore = 0;
        for (const entry of entries) {
          let score = this.u_SublpScorePlanName(entry.name, tier);
          if (score === 0 && token) {
            const escaped = token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            if (new RegExp(escaped, 'i').test(entry.name)) score = 40;
          }
          if (score > bestScore) {
            bestScore = score;
            best = entry;
          }
        }

        if (best && bestScore > 0) return best.selling_plan_id;

        console.warn('[mm-sublp] No selling plan matched tier:', tier, entries.map((e) => e.name));
        return null;
      },

      u_SublpAllocation(tier) {
        if (tier === 'one-time' || !this.currentVariant?.selling_plan_allocations?.length) return null;
        const planId = this.u_SublpResolveSellingPlanId(this.currentVariant, tier);
        if (!planId) return null;
        return this.currentVariant.selling_plan_allocations.find((a) => a.selling_plan_id == planId) || null;
      },

      e_SelectSubscriptionTier(tier) {
        this.subscriptionTier = tier;
        if (tier === 'one-time') {
          this.subscriptionType = 'one-time';
          this.sellingPlanId = null;
          return;
        }
        this.subscriptionType = 'subscribe';
        this.sellingPlanId = this.u_SublpResolveSellingPlanId(this.currentVariant, tier);
      },

      u_PerShotPrice(sizeValue, optionPosition) {
        let match = sizeValue.match(/(\d+)/);
        if (!match) return '';
        let packCount = parseInt(match[1], 10);

        let options = [...this.currentVariant.options];
        options[optionPosition - 1] = sizeValue;

        let targetVariant = this.product.variants.find((v) => v.options.join('/') === options.join('/'));
        if (!targetVariant) return '';

        let price;
        if (this.isSubscription && targetVariant.selling_plan_allocations?.length > 0) {
          let allocation = targetVariant.selling_plan_allocations.find((a) => a.selling_plan_id == this.sellingPlanId);
          if (!allocation) allocation = targetVariant.selling_plan_allocations[0];
          price = allocation.price;
        } else {
          price = targetVariant.price;
        }

        return u_FormatMoney(Math.round(price / packCount));
      },

      u_GetLeadingVariants(option_position, value) {
        if (option_position == 1) {
          return this.product.variants.filter((variant) => variant.option1 == value);
        }
        if (option_position == 2) {
          return this.product.variants.filter(
            (variant) => variant.option1 == this.currentVariant.option1 && variant.option2 == value
          );
        }
        if (option_position == 3) {
          return this.product.variants.filter(
            (variant) =>
              variant.option1 == this.currentVariant.option1 &&
              variant.option2 == this.currentVariant.option2 &&
              variant.option3 == value
          );
        }
        return [];
      },

      InitSwiper() {
        const mainEl = this.$el.querySelector('.mm-product-swiper');
        const thumbsEl = this.$el.querySelector('.mm-product-thumbs');
        if (!mainEl || !Swiper) return;

        if (this._mainSwiper) {
          this._mainSwiper.destroy(true, true);
          this._mainSwiper = null;
        }
        if (this._thumbsSwiper) {
          this._thumbsSwiper.destroy(true, true);
          this._thumbsSwiper = null;
        }

        this._thumbsSwiper = new Swiper(thumbsEl, {
          spaceBetween: 10,
          slidesPerView: 2.5,
          freeMode: true,
          watchSlidesProgress: true,
          navigation: {
            nextEl: this.$el.querySelector('.swiper-button-next'),
            prevEl: this.$el.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            750: {
              slidesPerView: 4,
            },
          },
        });
        this._mainSwiper = new Swiper(mainEl, {
          spaceBetween: 0,
          thumbs: this._thumbsSwiper ? { swiper: this._thumbsSwiper } : {},
          navigation: {
            nextEl: this.$el.querySelector('.swiper-button-next'),
            prevEl: this.$el.querySelector('.swiper-button-prev'),
          },
        });
        this._mainSwiper.slideTo(0, 0);
      },
    }));
  });
})();

(function () {
  const EXTRA = 550;
  const ROOT = '.mm-sublp-main-product';

  function patchBadge(el) {
    const inner = el.querySelector('.jdgm-prev-badge');
    if (inner) {
      const current = parseInt(inner.getAttribute('data-number-of-reviews'), 10);
      if (!isNaN(current) && !inner.dataset.patched) {
        inner.setAttribute('data-number-of-reviews', current + EXTRA);
        inner.dataset.patched = 'true';
      }
    }

    const textEl = el.querySelector('.jdgm-prev-badge__text');
    if (textEl && !textEl.dataset.patched) {
      const match = textEl.textContent.match(/(\d+)/);
      if (match) {
        const original = parseInt(match[1], 10);
        textEl.textContent = textEl.textContent.replace(String(original), String(original + EXTRA));
        textEl.dataset.patched = 'true';
      }
    }
  }

  const existing = document.querySelector(`${ROOT} .jdgm-widget`);
  if (existing) patchBadge(existing);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (!node.closest?.(ROOT) && !node.querySelector?.(`${ROOT} .jdgm-widget`)) continue;
        if (node.classList?.contains('jdgm-widget')) patchBadge(node);
        const nested = node.querySelector?.('.jdgm-widget');
        if (nested && nested.closest(ROOT)) patchBadge(nested);
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
